import { Extension } from "@builder/types/Extension.type";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";

export const EXTENSIONS_PATH = "/extensions";

export const extensionsApi = createApi({
    reducerPath: "extensions",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_HUB_API,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["extensions"],
    endpoints: builder => ({
        getExtensions: builder.query<Extension[], string>({
            query: companyId => `${EXTENSIONS_PATH}/${companyId}`,
            providesTags: ["extensions"]
        })
    })
});

export const { useGetExtensionsQuery } = extensionsApi;
